import { HTTPFetchError } from '@racemap/utilities/api-client';
import { sendErrorEvent } from 'src/lib/googleAnalytics';
import { toast } from 'src/lib/toast';
import type { SWRConfiguration } from 'swr';

export const swrConfig: SWRConfiguration = {
  onError: (error) => {
    if (process.env.NODE_ENV !== 'production') {
      if (error instanceof HTTPFetchError && error.status === 403) {
        console.warn(
          'Access forbidden. This may be due to insufficient permissions or an expired session.',
        );
      } else {
        toast.error('An error occurred while fetching data. Please try again later.');
      }

      console.error(error);
      return;
    }

    // In production these used to be swallowed whole, which made fetch failures — the most
    // likely symptom of a stale tab talking to a redeployed API — invisible. Report, but stay
    // silent in the UI: surfacing every transient 401 or offline blip would be worse than now.
    sendErrorEvent(error, false, {
      ...(error instanceof HTTPFetchError
        ? { status: error.status, path: error.path, method: error.method }
        : {}),
      source: 'swr',
    });
  },
};
